// A sync error as the screens show it: short, and never a whole page of HTML.

/** Longer than this, a stored error is cut short: one from before #387 can hold a whole HTML page. */
const MAX_ERROR_SHOWN = 160;

export function shortError(error: string): string {
  const text = error.includes('<') ? "The server couldn't be reached just now." : error.trim();
  const cut = text.length > MAX_ERROR_SHOWN ? `${text.slice(0, MAX_ERROR_SHOWN)}…` : text;
  return /[.!?…]$/.test(cut) ? cut : `${cut}.`;
}
